module.exports = __webpack_public_path__ + "img/1.8_Russian_road_sign.b484187f.svg";